module.exports = __webpack_public_path__ + "img/ps-deporte.62b71f98.jpg";